import React, { Component } from "react";

export default class Projects extends Component {
  render() {
    return (
      <section
        id="projects"
        className="colorlib-work"
        data-section="projects"
      >
        <div className="colorlib-narrow-content">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <span className="heading-meta">My Work</span>
              <h2 className="colorlib-heading animate-box">
                Projects
              </h2>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-4 text-center animate-box"
              data-animate-effect="fadeInLeft"
            >
              <div className="services color-1 project-card">
                <img
                  className="project-card-icon"
                  src="images/imerbot-icon.png"
                  alt="Imerbot app icon"
                />
                <div className="desc">
                  <h3>Imerbot</h3>
                  <p>
                    A mobile application that helps Mercado Libre sellers
                    manage and respond to questions from single or multiple
                    accounts.
                  </p>
                  <a
                    className="project-card-link"
                    href="https://imerbot.com.mx/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit imerbot.com.mx <i className="icon-arrow-right3" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
